/**
 * 用量反応・生存・反復など 3列コンパクト表の共通ヘルパ
 */

import { useEffect } from 'react';
import { KEISUKE_DASHBOARD_NEW_EVENT } from './KeisukeDashboardBarChartSettingsContext';

export type ThreeColumnRow = [string, string, string];

export function resizeThreeColumnRows(rows: ThreeColumnRow[], n: number): ThreeColumnRow[] {
  const next = rows.slice(0, n) as ThreeColumnRow[];
  while (next.length < n) next.push(['', '', '']);
  return next;
}

export function emptyThreeColumnRows(n: number): ThreeColumnRow[] {
  return Array.from({ length: Math.max(2, n) }, () => ['', '', ''] as ThreeColumnRow);
}

/** 「新規」でローカル表を空フォームへ戻す（ストア hydrate と併用） */
export function useKeisukeCompactFormResetOnNew(reset: () => void): void {
  useEffect(() => {
    window.addEventListener(KEISUKE_DASHBOARD_NEW_EVENT, reset);
    return () => window.removeEventListener(KEISUKE_DASHBOARD_NEW_EVENT, reset);
  }, [reset]);
}
